export const queuesConstants = {
  QUEUE_REQUEST: 'QUEUE_REQUEST',
  QUEUE_SUCCESS: 'QUEUE_SUCCESS',
  QUEUE_FAILURE: 'QUEUE_FAILURE',
};
